export enum Apps {
  server = 1,
  cloud = 2,
  enterprise = 3,
  business = 4,
  sites = 5,
  comply = 6
}
